








import InputField from "./InputField";
import { Editor, EditorContent } from "@tiptap/vue-2";
import Document from "@tiptap/extension-document";
import Paragraph from "@tiptap/extension-paragraph";
import Text from "@tiptap/extension-text";
import Blockquote from "@tiptap/extension-blockquote";
import BulletList from "@tiptap/extension-bullet-list";
import CodeBlock from "@tiptap/extension-code-block";
import HardBreak from "@tiptap/extension-hard-break";
import Heading from "@tiptap/extension-heading";
import ListItem from "@tiptap/extension-list-item";
import OrderedList from "@tiptap/extension-ordered-list";
import Bold from "@tiptap/extension-bold";
import Italic from "@tiptap/extension-italic";
import Strike from "@tiptap/extension-strike";
import History from "@tiptap/extension-history";
import HorizontalRule from "@tiptap/extension-horizontal-rule";
import Link from "@tiptap/extension-link";

export default {
    name: "HtmlTextareaInput",
    components: { InputField, EditorContent },
    props: {
        label: String,
        value: String,
    },
    data() {
        return {
            editor: null,
        };
    },
    created() {
        var self = this;
        this.editor = new Editor({
            content: this.value,
            extensions: [
                Document,
                Paragraph,
                Text,
                Blockquote,
                BulletList,
                CodeBlock,
                HardBreak,
                Heading,
                ListItem,
                OrderedList,
                Bold,
                Italic,
                Strike,
                History,
                HorizontalRule,
                Link,
            ],
            onUpdate({ editor }) {
                self.$emit("input", editor.getHTML());
            },
        });
    },
    beforeDestroy() {
        this.editor.destroy();
    },
    watch: {
        value: {
            handler: function () {
                if (this.editor && this.value != this.editor.getHTML()) {
                    this.editor.commands.setContent(this.value);
                }
            },
        },
    },
};
